/** The hover of the ticket's "Investigate" (the page-look round, 2026-10-29; brief rule 5): what the AI can read on this ticket (the repository,
 *  the pages the customer linked, or both), then the effort in effect: "in omnalingo-plugin and the pages the customer linked · Standard · up
 *  to 2 credits". Nothing to name: the effort alone. */
export function investigateHover(investigable: { repo: string | null; pages: boolean } | undefined, effort: string): string {
  const reads = [investigable?.repo ? `in ${investigable.repo}` : null, investigable?.pages ? "the pages the customer linked" : null].filter(Boolean).join(" and ");
  return reads ? `${reads} · ${effort}` : effort;
}
